import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import * as actions from '../../../actions/sports'
import { updateCalculator, clearCalculator } from '../../../actions/calculator'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import Banner from '../../Calculator/Banner'
import SportCard from '../../Calculator/Card/SportCard'
import CalcettoImage from '../../../assets/images/homepage-calcetto.jpg'
import BasketImage from '../../../assets/images/homepage-basket.jpg'
import BeachImage from '../../../assets/images/homepage-beachvolley.jpg'
import Button from '../../UI/Button'
import CaretIcon from '../../UI/Icons/CaretIcon'

// The 3 sports to choose from
const cards = [
  {
    id: 1,
    token: 'calcetto',
    title: 'Calcetto',
    description: 'a partire da 1.760 €',
    footerText1: 'Calcetto 5vs5 / 7vs7',
    footerText2: 'Gabbia 2vs2 / 3vs3',
    image: CalcettoImage,
    selected: true
  },
  {
    id: 2,
    token: 'basket',
    title: 'Basket',
    description: 'a partire da 700 €',
    footerText1: 'Solo canestro',
    footerText2: 'Campo 3vs3 / 5vs5',
    image: BasketImage
  },
  {
    id: 3,
    token: 'beach-volley',
    title: 'Beach Volley',
    description: 'a partire da 850 €',
    footerText1: 'Solo dotazione tecnica',
    footerText2: 'Campo completo',
    image: BeachImage
  }
]

export const Wrapper = styled.div`
  width: 95%;
  margin-top: 30px;

  @media ${device.tablet} {
  ${''/* width: 520px; */}
    width: 67.70833333333334vw;
    margin-top: 0;
  }

  @media ${device.laptopM} {
    ${''/* width: 1280px; */}
    width: 66.66666666666667vw;
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: ${props => props.cardCount < 3 ? 'center' : 'space-between'};
  flex-wrap: wrap;

  @media ${device.mobileM} {
    justify-content: space-around;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Caret = styled(CaretIcon)`
  ${''/* width: 10px; */}
  width: 0.5208333333333334vw;

  @media ${device.mobileL} {
    width: 6px;
  }
`

class Step0 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedSport: '' // Set initial selection to the first card
    }
  }

  componentDidMount () {
    this.props.fetchSports()
    // If a sport has already been selected, show the sport
    if (this.props.selectedSport) {
      this.setState({ selectedSport: cards[this.props.selectedSport - 1] })
    }
  }

  handleCardSelection (id) {
    const selectedSport = cards[id - 1]
    if (selectedSport) {
      const path = `/noleggia/${selectedSport.token}/1`
      // New sport so fresh start for calculator
      this.props.clearCalculator(() => { // Callback to updated the step 1 details and redirect
        // Storing the path and selcted sport ID in state
        this.props.updateCalculator(1, { path, sportId: selectedSport.id })
        this.props.history.push(path)
      })
    }
  }

  handleNext () {
    const { selectedSport } = this.state
    if (selectedSport) {
      const path = `/noleggia/${selectedSport.token}/1`
      // New sport so fresh start for calculator
      this.props.clearCalculator(() => { // Callback to updated the step 1 details and redirect
        this.props.updateCalculator(1, { path, sportId: selectedSport.id })
        this.props.history.push(path)
      })
    }
  }

  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Noleggio campi smontabili</title>
          <meta name='Description' content='Il primo configuratore on-line per calcolare in modo facile e gratuito il costo del tuo noleggio di campi calcetto, campi da basket e campi beach volley!' />
          <meta name='Keywords' content='campo calcetto costo,campo basket smontabile,campo beach volley' />
        </Helmet>
        <Banner
          title='CAMPI DA GIOCO'
          subtitle='A QUALE SPORT;SEI INTERESSATO?'
        />
        <Content>
          {cards.map((card, i) => (
            <SportCard
              key={i}
              title={card.title}
              description={card.description}
              footerText1={card.footerText1}
              footerText2={card.footerText2}
              image={card.image}
              selected={this.state.selectedSport.id === card.id} // Check if selected sport ID is equal to current card ID
              onClick={this.handleCardSelection.bind(this, card.id)}
            />
          ))}
        </Content>
        <ButtonWrapper>
          <Button onClick={this.handleNext.bind(this)} size='small'>VAI AVANTI <Caret fill='#fff' style={{ paddingLeft: '40px' }} /></Button>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    sports: state.sports.data,
    selectedSport: state.calculator.steps[0].sportId
  }
}

export default connect(mapStateToProps, { updateCalculator, clearCalculator, ...actions })(Step0)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step0.js